import React from "react";

/**
 * Trend line for a short series, sized to sit inside a table cell.
 *
 * Hand-rolled SVG rather than Recharts on purpose: `ResponsiveContainer`
 * measures its parent at layout time and collapses to zero height in a print
 * context, which would silently blank every sparkline in the exported PDF —
 * the one output this feature exists to produce.
 *
 * `null` entries are gaps (a day with no check-in), not zeros: the line skips
 * them instead of diving to the floor and inventing a crash.
 */
const Sparkline = ({ values = [], width = 84, height = 24, label }) => {
  const recorded = values.filter((v) => typeof v === "number" && Number.isFinite(v));

  if (recorded.length < 2) {
    return <span className="text-[11px] text-peri-300">Sin datos</span>;
  }

  const min = Math.min(...recorded);
  const max = Math.max(...recorded);
  const span = max - min || 1;
  const step = (width - 8) / Math.max(values.length - 1, 1);

  const points = [];
  values.forEach((value, index) => {
    if (typeof value !== "number" || !Number.isFinite(value)) return;
    points.push([4 + index * step, height - 3 - ((value - min) / span) * (height - 8)]);
  });

  const last = points[points.length - 1];
  const rising = recorded[recorded.length - 1] >= recorded[0];
  const stroke = rising ? "#0f8a6a" : "#f22601";

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      role="img"
      aria-label={
        label ||
        `Tendencia: ${rising ? "al alza" : "a la baja"}, de ${recorded[0]} a ${recorded[recorded.length - 1]}`
      }
    >
      <polyline
        points={points.map((p) => p.join(",")).join(" ")}
        fill="none"
        stroke={stroke}
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {last && <circle cx={last[0]} cy={last[1]} r="2.6" fill={stroke} />}
    </svg>
  );
};

export default Sparkline;
